module.exports = __webpack_public_path__ + "img/logo-escola.80d6357d.png";